export default __webpack_public_path__ + "static/media/clarinet_one.6bdabc86.mp3";